import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export class About {
  constructor() {
    this.initTextReveal();
  }

  initTextReveal() {
    const descriptionEl = document.querySelector('.convictions-description');
    if (!descriptionEl) return;

    // Récupérer tout le contenu HTML et le transformer en caractères individuels
    const paragraphs = descriptionEl.querySelectorAll('p');

    if (paragraphs.length === 0) {
      // Si pas de balises p, traiter le contenu directement
      this.wrapCharacters(descriptionEl);
    } else {
      // Traiter chaque paragraphe
      paragraphs.forEach(p => {
        this.wrapCharacters(p);
      });
    }

    // Récupérer tous les caractères
    const chars = descriptionEl.querySelectorAll('.char');

    if (chars.length === 0) return;

    // Animation GSAP avec ScrollTrigger
    gsap.to(chars, {
      scrollTrigger: {
        trigger: '.convictions-row-2',
        start: 'top 80%',
        end: 'bottom 40%',
        scrub: 1,
      },
      opacity: 1,
      stagger: 0.02,
      ease: 'none'
    });
  }

  wrapCharacters(element) {
    const text = element.innerHTML;
    let result = '';
    let inTag = false;
    let currentTag = '';

    for (let i = 0; i < text.length; i++) {
      const char = text[i];

      // Détecter les balises HTML
      if (char === '<') {
        inTag = true;
        currentTag = '<';
        continue;
      }

      if (inTag) {
        currentTag += char;
        if (char === '>') {
          inTag = false;
          result += currentTag;
          currentTag = '';
        }
        continue;
      }

      // Wrapper chaque caractère (y compris les espaces)
      if (char === ' ') {
        // Utiliser un espace normal pour permettre le retour à la ligne
        result += ' ';
      } else if (char === '\n' || char === '\r') {
        result += char;
      } else {
        result += `<span class="char">${char}</span>`;
      }
    }

    element.innerHTML = result;
  }
}
